import { jsxs as c, jsx as o, Fragment as u } from "react/jsx-runtime";
import { s as r, r as B, c as C } from "./themes-5f0b3c3d.mjs";
import { useState as w, useEffect as v, Children as g, cloneElement as D } from "react";
import { u as x } from "./index-6a632112.mjs";
import { S as h } from "./types-b577bf77.mjs";
import { Button as F } from "./button.js";
import "./lineHeights-72d3110c.mjs";
import "./textStyles-42cab346.mjs";
import "./fontWeights-a25f8f91.mjs";
import "./accessibility.js";
function H({
  title: e,
  titleId: l,
  size: t,
  height: s,
  width: a,
  ...d
}) {
  const n = t ? h[t] : h.s;
  return /* @__PURE__ */ c(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 72 72",
      height: t ? n : s || n,
      width: t ? n : a || n,
      "aria-labelledby": l,
      ...d,
      children: [
        e ? /* @__PURE__ */ o("title", { id: l, children: e }) : null,
        /* @__PURE__ */ o("g", { clipPath: "url(#Caret-Down__Filled_svg__a)", children: /* @__PURE__ */ o(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M36 1.5c19.054 0 34.5 15.446 34.5 34.5 0 19.054-15.446 34.5-34.5 34.5C16.946 70.5 1.5 55.054 1.5 36 1.5 16.946 16.946 1.5 36 1.5Zm14.231 21.347-14.2 14.2-14.201-14.2-6.099 6.099 20.3 20.3 20.299-20.3-6.099-6.1Z",
            clipRule: "evenodd"
          }
        ) }),
        /* @__PURE__ */ o("defs", { children: /* @__PURE__ */ o("clipPath", { id: "Caret-Down__Filled_svg__a", children: /* @__PURE__ */ o("path", { fill: "currentColor", d: "M0 0h72v72H0z" }) }) })
      ]
    }
  );
}
function P({
  title: e,
  titleId: l,
  size: t,
  height: s,
  width: a,
  ...d
}) {
  const n = t ? h[t] : h.s;
  return /* @__PURE__ */ c(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 72 72",
      height: t ? n : s || n,
      width: t ? n : a || n,
      "aria-labelledby": l,
      ...d,
      children: [
        e ? /* @__PURE__ */ o("title", { id: l, children: e }) : null,
        /* @__PURE__ */ o("g", { clipPath: "url(#Caret-up__Filled_svg__a)", children: /* @__PURE__ */ o(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M36 1.5c19.054 0 34.5 15.446 34.5 34.5 0 19.054-15.446 34.5-34.5 34.5C16.946 70.5 1.5 55.054 1.5 36 1.5 16.946 16.946 1.5 36 1.5Zm.262 20.038-20.3 20.3 6.099 6.098 14.2-14.2 14.201 14.2 6.099-6.099-20.3-20.3Z",
            clipRule: "evenodd"
          }
        ) }),
        /* @__PURE__ */ o("defs", { children: /* @__PURE__ */ o("clipPath", { id: "Caret-up__Filled_svg__a", children: /* @__PURE__ */ o("path", { fill: "currentColor", d: "M0 0h72v72H0z" }) }) })
      ]
    }
  );
}
const R = x.div`
  display: ${({ $alignment: e }) => e === "inline" ? "inline-flex" : "flex"};
  height: ${({ $alignment: e }) => e === "inline" ? r["6x"] : r["10x"]};
  padding: ${({ $alignment: e }) => e === "left" ? `${r["2x"]} ${r["4x"]} ${r["2x"]} 0px ` : e === "inline" ? "0px" : `${r["2x"]} ${r["4x"]}`};
  box-sizing: border-box;
  width: fit-content;
  ${(e) => e.$alignment === "center" && "margin: 0px auto"};
  ${(e) => e.$alignment === "center" && "justify-content: center"};
  &:hover {
    .show-more-icon {
      color: ${(e) => e.theme.components.showMoreLess.labelTextHoverColor};
      cursor: pointer;
    }
    span {
      color: ${(e) => e.theme.components.showMoreLess.labelTextHoverColor};
      cursor: pointer;
      border-bottom: ${r.px} solid
        ${(e) => e.theme.components.showMoreLess.labelBorderColor};
    }
  }

  &:focus-visible {
    ${(e) => `
      && > div {
          outline: 2px solid
              ${e.theme.components.showMoreLess.focusRingColor};
          border-radius: ${B["2x"]};
          padiing: 2px;
          outline-offset:2px;
      }
      outline: none;
        `}
  }
`, k = x.div`
  ${(e) => e.$alignment === "inline" && "display : inline-block"};
`, Z = x(F)`
  padding: unset !important;
  background-color: transparent !important;
  color: ${(e) => e.disabled ? e.theme.components.showMoreLess.labelTextDisabledColor : e.theme.components.showMoreLess.labelTextColor} !important;
  &:hover {
    background-color: transparent !important;
    text-decoration: ${(e) => e.disabled ? "unset" : "underline"};
    color: ${(e) => e.disabled ? e.theme.components.showMoreLess.labelTextDisabledColor : e.theme.components.showMoreLess.labelTextHoverColor} !important;
    && > {
      color: ${(e) => e.disabled ? e.theme.components.showMoreLess.labelTextDisabledColor : e.theme.components.showMoreLess.labelTextHoverColor} !important;
    }
  }
  & svg {
    ${(e) => `
      ${e.disabled ? `
      color: ${e.theme.components.showMoreLess.svgDisabledColor} !important;
      ` : ""}`}
  }
`, O = ({
  alignment: e = "left",
  className: l,
  children: t,
  previewContent: s,
  disabled: a,
  ...d
}) => {
  const [n, $] = w(!1), [p, M] = w(""), [m, _] = w("left");
  v(() => {
    M(s);
  }, [s]), v(() => {
    _(e);
  }, [e]);
  const L = () => {
    $(!n);
  }, S = () => n ? /* @__PURE__ */ o(
    P,
    {
      "aria-label": "caret-up",
      height: "20px",
      width: "20px",
      color: C.accentBlue[1e3],
      className: "show-more-icon"
    }
  ) : /* @__PURE__ */ o(
    H,
    {
      "aria-label": "caret-down",
      height: "20px",
      width: "20px",
      color: C.accentBlue[1e3],
      className: "show-more-icon"
    }
  ), f = () => /* @__PURE__ */ c(u, { children: [
    /* @__PURE__ */ o("span", { style: { padding: `0 ${r["2x"]}` } }),
    /* @__PURE__ */ o(
      R,
      {
        onClick: L,
        className: l,
        $alignment: m,
        tabIndex: 0,
        "aria-label": "show-more-less",
        children: /* @__PURE__ */ o(
          Z,
          {
            size: "medium",
            variant: "text",
            rightIcon: S(),
            disabled: a,
            children: n ? "Show Less" : "Show More"
          }
        )
      }
    )
  ] });
  return /* @__PURE__ */ o(k, { $alignment: m, className: l, children: m === "inline" ? (() => g.map(
    n ? t : p,
    (i, y) => {
      const T = n ? g.count(t) : g.count(p);
      if (y === T - 1) {
        const b = /* @__PURE__ */ c(u, { children: [
          typeof i == "string" || !i?.props?.children ? i : i.props.children,
          f()
        ] });
        return typeof i == "string" || !i?.props?.children ? b : D(i, {
          children: b
        });
      } else
        return i;
    }
  ))() : (() => /* @__PURE__ */ c(u, { children: [
    n ? t : p,
    f()
  ] }))() });
};
export {
  O as ShowMoreLess
};
